import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-table-header-edit-state',
  templateUrl: './table-header-edit-state.component.html',
  styleUrls: ['./table-header-edit-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableHeaderEditStateComponent {
  @Input() title = 'Manage columns';
  @Input() disabled = false;
  @Output() submit = new EventEmitter<boolean>();
}
